import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { TextBoxEditor } from "../../../../../../../../react-core/Html/TextBoxEditor";

export interface AccountNameProps extends IProcessComponentProps {
    AccountName?: string;
}

export interface AccountNameState {
    HasAccountNameGiven?: boolean;
}

export class AccountName extends ProcessComponent<AccountNameProps, AccountNameState> {
    constructor(props: any) {
        super(props);
        this.state = {
            HasAccountNameGiven: props.data?.AccountNameGiven?.HasAccountNameGiven ? true : false,
        };
    }

    private renderAccountNameField(data, onChange) {
        return (
            <>
                <TextBoxEditor
                    label={this.props.AccountName ? this.props.AccountName : "Account name"}
                    required="Please enter account name"
                    cssWrapper="control-size-430"
                    value={this.props.data.AccountNameGiven?.AccountNameGivenDetail}
                    onChange={(v) =>
                        this.props.onChange({
                            AccountNameGivenDetail: v,
                            HasAccountNameGiven: this.state.HasAccountNameGiven,
                        })
                    }
                />
            </>
        );
    }

    private renderAccountName(data, onChange) {
        return (
            <>
                <RadiosEditor
                    cssWrapper="radio-group rg-inline rg-150 mb-16"
                    label={"Would you like to give the Personal Portfolio a name?"}
                    selected={this.state.HasAccountNameGiven}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => this.onIsAccountNameSelectedChange(v)}
                    required={"Please select"}
                />
                {this.state.HasAccountNameGiven && this.renderAccountNameField(data, onChange)}
            </>
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return <>{this.renderAccountName(data, onChange)}</>;
    }

    private onIsAccountNameSelectedChange(v) {
        this.props.onChange({ HasAccountNameGiven: v, AccountNameGivenDetail: "" });
        this.setState({ HasAccountNameGiven: v });
    }
}
